<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-header bg-transparent pb-5">
                        <div class="text-muted text-center mt-2 mb-3">
                            <h1>{{$t('header_1')}}</h1>
                            <h4>{{$t('header_2')}}</h4>
                            <h3 style="color:red">{{$t('header_3')}}</h3>
                        </div>
                    </div>
                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center text-muted mb-4">
                           {{$t('forget_password')}}
                        </div>
                        <ValidationObserver v-slot="{ passes }">
                            <form @submit.prevent="passes(onSubmit)">
                                <base-input class="input-group-alternative mb-3"
                                            :name="$t('email')"
                                            :label="$t('email')"
                                            required
                                            rules="required|email"
                                            :placeholder="$t('email')"
                                            v-model="form.email">
                                </base-input>
                                <div class="text-center">
                                    <base-button nativeType="submit" type="primary" class="my-4">{{$t('reset_password')}}</base-button>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <router-link :to="'/'+$i18n.locale+'/login'" class="text-light">
                            <small>{{$t('login')}}</small>
                        </router-link>
                    </div>
                    <div class="col-6 text-right">
                        <router-link :to="'/'+$i18n.locale+'/register'" class="text-light"><small>{{$t('create_account')}}</small></router-link>
                    </div>
                </div>
            </div>
            <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal>
            
            <modal :show.sync="modal_send_email">

            <p>{{$t('please_check_email')}}</p>

            <template slot="footer">
                <base-button @click="modal_send_email = false" type="primary">{{$t('close')}}</base-button>
            </template>

            </modal>

        </div>
    </div>
</template>
<script>
import { ValidationObserver } from "vee-validate"
import i18n from "@/i18n"
  export default {
    name: 'forget',
    components: {
        ValidationObserver
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        modal_send_email: false,
        form: {
          email: ''
        }
      }
    },
    created () {
        this.checkCurrentLogin()
    },
    updated () {
        this.checkCurrentLogin()
    },
    methods: {
        checkCurrentLogin () {
            if (this.$store.state.token) {
                this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/dashboard')
            }
        },
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        onSubmit () {
            this.$http.post('auth/forgetPassword', {
                "email": this.form.email
            })
                .then(request => this.onSubmitSuccessful(request))
                .catch(() => this.onSubmitFailed())
        },
        onSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.onSubmitFailed(req)
                return
            }
            this.modal_send_email = true
        },
        onSubmitFailed (req) {
            this.modalAlert(req)
        }
    }
  }
</script>
<style>
</style>
